module.exports = __webpack_public_path__ + "static/media/pheasant_specification_en.f90ddbba.md";